module.exports = __webpack_public_path__ + "assets/img/chase.10c86cbf.svg";